
import React from "react";
import { Progress } from "@/components/ui/progress";
import { Card } from "@/components/ui/card";

interface KarmaStatsProps {
  karmaPoints: number;
  levelThresholds: number[];
  getCurrentLevel: (points: number) => number;
  getProgressToNextLevel: (points: number) => number;
}

const KarmaStats: React.FC<KarmaStatsProps> = ({
  karmaPoints,
  levelThresholds,
  getCurrentLevel,
  getProgressToNextLevel
}) => {
  const currentLevel = getCurrentLevel(karmaPoints);
  const nextLevel = currentLevel < levelThresholds.length - 1 ? currentLevel + 1 : currentLevel;
  const progress = getProgressToNextLevel(karmaPoints);
  
  return (
    <div className="bg-background p-5 rounded-lg border">
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="p-4 bg-muted/30 rounded-lg text-center">
          <h3 className="font-medium text-sm text-muted-foreground">Current Level</h3>
          <div className="text-3xl font-bold mt-1">{currentLevel}</div>
        </div>
        <div className="p-4 bg-muted/30 rounded-lg text-center">
          <h3 className="font-medium text-sm text-muted-foreground">Karma Points</h3>
          <div className="text-3xl font-bold mt-1">{karmaPoints}</div>
        </div>
      </div>
      
      <div className="mt-2">
        <div className="flex justify-between text-sm mb-1.5">
          <span>Progress to Level {nextLevel}</span>
          <span>{progress}%</span>
        </div>
        <Progress value={progress} className="h-2.5 bg-muted" />
        
        {currentLevel < levelThresholds.length - 1 && (
          <div className="flex justify-between text-xs text-muted-foreground mt-1.5">
            <span>{karmaPoints} points</span>
            <span>{levelThresholds[nextLevel]} points</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default KarmaStats;
